import { useI18n } from "../i18n";

const steps = [
    "01",
    "02",
    "03",
    "04",
];

const AboutProcess = () => {
    const { about } = useI18n();

    return (
        <section className="bg-white px-6 py-20 md:px-12 md:py-28">
            <div className="mx-auto max-w-7xl">
                <div className="mb-14 max-w-3xl">
                    <p className="mb-4 flex items-center gap-3 text-xs font-bold uppercase tracking-[0.22em] text-sky-700 sm:text-sm">
                        <span className="h-px w-8 bg-sky-500" />
                        {about.processEyebrow}
                    </p>

                    <h2 className="text-3xl font-extrabold tracking-tight text-slate-900 md:text-5xl">
                        {about.processTitle}
                    </h2>

                    <p className="mt-5 leading-7 text-slate-600">
                        {about.processIntro}
                    </p>
                </div>

                <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-4">
                    {about.processSteps.map((step, index) => (
                        <article key={steps[index]} className="relative">
                            <div className="flex items-center gap-4">
                                <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full border border-sky-200 bg-sky-50 text-sm font-extrabold text-sky-700">
                                    {steps[index]}
                                </div>

                                {index !== steps.length - 1 && (
                                    <div className="hidden h-px flex-1 bg-gradient-to-r from-sky-300 to-slate-200 lg:block" />
                                )}
                            </div>

                            <h3 className="mt-6 text-xl font-bold text-slate-900">
                                {step.title}
                            </h3>

                            <p className="mt-3 text-sm leading-7 text-slate-600">
                                {step.description}
                            </p>
                        </article>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default AboutProcess;
